<template>
  <van-overlay :show="show" :z-index="3000" @click="close">
    <div class="pc-login-dialog__wrap">
      <div class="pc-login-dialog__panel" @click.stop>
        <div class="pc-login-dialog__close" @click="close">×</div>

        <div class="pc-login-dialog__title">
          微信扫码关注“小小签到”公众号登录
        </div>

        <div class="pc-login-dialog__qr-box" :class="{ 'pc-login-dialog__qr-box--expired': showMaskLayer }">
          <img v-if="qrImg" class="pc-login-dialog__qr" :src="qrImg" alt="公众号扫码登录二维码" />
          <div v-else class="pc-login-dialog__placeholder"></div>

          <div v-if="showMaskLayer" class="pc-login-dialog__mask">
            <div class="pc-login-dialog__mask-text">
              {{ errorText || "二维码已失效" }}
            </div>
            <div class="pc-login-dialog__mask-button" @click="refresh">
              刷新二维码
            </div>
          </div>
        </div>

        <div class="pc-login-dialog__agreement">
          <div class="pc-login-dialog__check">✓</div>
          <div class="pc-login-dialog__agreement-text">
            扫码注册后代表您阅读并同意
            <span class="pc-login-dialog__agreement-link" @click="openAgreement">
              《用户协议》
            </span>
          </div>
        </div>

      </div>
    </div>
  </van-overlay>
</template>

<script>
import config from "@/utils/config";
import http from "@/utils/request";
import api from "@/utils/api";
import { initZhiniCustomer } from "@/utils/common";

const QR_EXPIRE_MS = 60 * 1000;

export default {
  name: "PcLoginDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qrImg: "",
      qrToken: "",
      pollTimer: null,
      qrStartAt: 0,
      loading: false,
      qrExpired: false,
      errorText: "",
    };
  },
  computed: {
    // 获取失败和二维码超时都复用同一层遮罩样式。
    showMaskLayer() {
      return this.qrExpired || (!!this.errorText && !this.loading);
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initDialog();
        } else {
          this.resetDialog();
        }
      },
    },
  },
  beforeDestroy() {
    this.resetDialog();
  },
  methods: {
    // 用时间戳 + 随机数生成一次性的扫码 token，和现有页面保持一致。
    createToken() {
      return (
        Date.now() + Math.ceil(Math.random() * 1000000000000000) + ""
      );
    },
    close() {
      this.$emit("close");
    },
    initDialog() {
      this.resetDialog();
      this.fetchQrcode();
    },
    // 每次关闭或重新打开弹窗时，把上一轮二维码和轮询状态彻底清掉。
    resetDialog() {
      this.stopPolling();
      this.qrImg = "";
      this.qrToken = "";
      this.qrStartAt = 0;
      this.loading = false;
      this.qrExpired = false;
      this.errorText = "";
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    refresh() {
      this.initDialog();
    },
    // 首次打开弹窗或点击刷新时，重新向后端申请一张新的登录二维码。
    fetchQrcode() {
      this.loading = true;
      this.qrExpired = false;
      this.errorText = "";
      this.qrToken = this.createToken();
      http
        .get(api.checkin.loginQr, {
          token: this.qrToken,
        })
        .then((data) => {
          if (!this.show) {
            return;
          }
          this.loading = false;
          if (data.sta == 0 && data.data && data.data.qrcode) {
            this.qrImg = data.data.qrcode;
            this.startPolling();
            return;
          }
          this.errorText = data.msg || "二维码获取失败";
        })
        .catch(() => {
          this.loading = false;
          this.errorText = "二维码获取失败";
        });
    },
    // 二维码拿到后开始轮询登录状态，并记录二维码的生效开始时间。
    startPolling() {
      this.stopPolling();
      this.qrStartAt = Date.now();
      this.pollTimer = setInterval(() => {
        this.checkLoginStatus();
      }, 2000);
    },
    // 轮询接口只负责两件事：判断二维码是否超时，以及判断扫码登录是否成功。
    checkLoginStatus() {
      if (!this.qrToken) {
        return;
      }

      if (Date.now() - this.qrStartAt >= QR_EXPIRE_MS) {
        this.stopPolling();
        this.qrExpired = true;
        this.errorText = "二维码已失效";
        return;
      }

      http
        .get(api.checkin.loginCheckStatus, {
          token: this.qrToken,
        })
        .then((data) => {
          if (!this.show) {
            return;
          }
          if (data.sta == -1) {
            return;
          }

          if (data.sta == 0 && data.data) {
            let userInfo = data.data;
            if (userInfo.access_token) {
              config.TOKEN = userInfo.access_token;
              localStorage.setItem("token", userInfo.access_token);
            }
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            initZhiniCustomer(userInfo);
            this.stopPolling();
            this.$emit("success", userInfo);
            this.$emit("close");
            return;
          }

          this.stopPolling();
          this.qrExpired = true;
          this.errorText = data.msg || "二维码已失效";
        })
        .catch(() => {
          this.stopPolling();
          this.errorText = "二维码获取失败";
        });
    },
    openAgreement() {
      window.open("https://xiaoqiandao.com/agreement", "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.pc-login-dialog__wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.pc-login-dialog__panel {
  position: relative;
  width: 100%;
  max-width: 360px;
  padding: 28px 28px 36px;
  background: #ffffff;
  border-radius: 2px;
  box-sizing: border-box;
}

.pc-login-dialog__close {
  position: absolute;
  top: 12px;
  right: 18px;
  width: 28px;
  height: 28px;
  font-size: 26px;
  line-height: 28px;
  text-align: center;
  color: #c9c9c9;
  cursor: pointer;
}

.pc-login-dialog__title {
  text-align: center;
  font-size: 18px;
  line-height: 30px;
  color: #3d3d3d;
  margin: 18px auto 0;
  max-width: 290px;
}

.pc-login-dialog__qr-box {
  width: 200px;
  height: 200px;
  margin: 10px auto 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc-login-dialog__qr-box--expired .pc-login-dialog__qr,
.pc-login-dialog__qr-box--expired .pc-login-dialog__placeholder {
  opacity: 0.12;
}

.pc-login-dialog__qr {
  width: 100%;
  height: 100%;
  display: block;
}

.pc-login-dialog__placeholder {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.pc-login-dialog__mask {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.pc-login-dialog__mask-text {
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  color: #333333;
}

.pc-login-dialog__mask-button {
  min-width: 80px;
  height: 32px;
  margin-top: 14px;
  padding: 0 18px;
  border-radius: 6px;
  background: #1ca3ec;
  color: #ffffff;
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.pc-login-dialog__agreement {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4c9dff;
  font-size: 12px;
  line-height: 20px;
}

.pc-login-dialog__check {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  border-radius: 3px;
  background: #4c9dff;
  color: #ffffff;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  flex: 0 0 auto;
}

.pc-login-dialog__agreement-text {
  color: #4c9dff;
}

.pc-login-dialog__agreement-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PcLoginDialog.vue